import { FETCH_FEATURE_ACCESS, CLEAN_AUTH } from "../actions/type";

// `access` is null while unknown (treated as "no" by the navbars).
// `incomplete`: the server could not decide every feature (those are false
// in `access` meanwhile) and is asked again.
const INITIAL_STATE = { access: null, incomplete: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FEATURE_ACCESS:
      return {
        ...state,
        access: action.payload.access,
        incomplete: !!action.payload.incomplete
      };
    case CLEAN_AUTH:
      return INITIAL_STATE;
    default:
      return state;
  }
};
